import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RadioBoxViewModel from '@/ViewModels/Controls/RadioBoxViewModel';
import { IRadioBoxGroupViewModelConstructorParameter } from "#/DefaultViewExtensionInterfaces";

export default class RadioBoxGroupViewModel extends ControlViewModel {

    /**
     * Die Ausrichtung der RadioBoxen
     */
    public orientation: string;

    /**
     * Beinhaltet die RadioBoxen
     */
    public items: KnockoutObservableArray<RadioBoxViewModel>;

    /**
     * Der aktuell selektierte Wert innerhalb der Gruppe
     */
    public selectedValue: KnockoutObservable<string>;
    
    private checkedSubscriptions: KnockoutSubscription[];
    private isInReset: boolean = false;

    /**
     * Das ViewModel für die RadioBoxGroup
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: IRadioBoxGroupViewModelConstructorParameter) {
        super(params);

        this.orientation = this.paramOrDefault(params.orientation, 'horizontal');
        this.items = this.observableOrDefault(params.items, []) as KnockoutObservableArray<RadioBoxViewModel>;
        this.selectedValue = this.observableOrDefault(params.selectedValue, '');

        this.checkedSubscriptions = [];
        
        this.createItemsSubscriptions();
    }

    public selectValue(value: string) {
        this.selectedValue(value);
    }
    
    /**
     * Kümmert sich darum, dass mögliche Updates der Items korrekt behandelt werden:
     * Es können neue Items hinzukommen, oder Items entfernt werden
     */
    private createItemsSubscriptions() {
        this.defineSubscription(this.items, (items) => {
            for (const sub of this.checkedSubscriptions)
                sub.dispose();

            this.checkedSubscriptions = [];

            for (const item of items) {
                const sub = this.ensureOnlyOneItemIsSelected(item);
                this.checkedSubscriptions.push(sub);
            }
        })(this.items());
    }

    private ensureOnlyOneItemIsSelected(item: RadioBoxViewModel): KnockoutSubscription {
        return item.checked.subscribe((val) => {
            if (this.isInReset)
                return;

            this.selectedValue(val);

            // Nur wenn ein neuer Wert gesetzt wird, sollen die anderen Boxen deselektiert werden
            if (val === '')
                return;

            this.isInReset = true;
            const others = this.items().filter(radio => radio.value !== val) as Array<RadioBoxViewModel>;
            for (let box of others) {
                // Es kann Fälle geben, wo zwei Boxen für 'checked' das gleiche Observable verwenden.
                // Das funktioniert nur, weil 'checked' als String gehandhabt wird. Damit es nicht zu Wechselwirkungen
                // kommt überspringen wir das Zurücksetzen der Werte bei gleicher Referenz.
                if (box.checked === item.checked)
                    continue;
                
                box.checked('');
            }
            this.isInReset = false;
        });
    }
}

ComponentManager.setViewModel('RadioBoxGroupViewModel', RadioBoxGroupViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');